module.exports = __webpack_public_path__ + "img/content_btn_play.4748d4b1.svg";